import {Paper, Stack, Typography, IconButton} from '@mui/material';
import ExpandIcon from '$assets/svgs/expand-icon.svg?react';
import CoinsIcon from '$assets/svgs/coins-icon.svg?react';
import {
  headerContainerStyle,
  titleContainerStyle,
  titleStyle,
  amountStyle,
  descriptionStyle,
  monthStyle,
} from './styles';
import {cardStyle} from '../../styles';
import {DashboardData} from '$api/finance/dashboard';
import {formatMonthYear} from '~/modules/frontdesk/utils';

interface MonthlyRevenueCardProps {
  onExpand?: () => void;
  data: DashboardData;
}

const MonthlyRevenueCard: React.FC<MonthlyRevenueCardProps> = ({
  onExpand,
  data,
}) => {
  const {total_revenue, current_month} = data.monthly_revenue;
  return (
    <Paper sx={cardStyle}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={headerContainerStyle}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={titleContainerStyle}
        >
          <CoinsIcon />
          <Typography variant="h6" sx={titleStyle}>
            Monthly revenue
          </Typography>
        </Stack>
        <IconButton onClick={onExpand}>
          <ExpandIcon />
        </IconButton>
      </Stack>
      <Typography variant="h2" sx={amountStyle}>
        £{total_revenue.toLocaleString()}
      </Typography>
      <Typography sx={descriptionStyle}>
        total payments received
        <br />
        in the current month
      </Typography>
      <Typography sx={monthStyle}>{formatMonthYear(current_month)}</Typography>
    </Paper>
  );
};

export default MonthlyRevenueCard;
